import styled from 'styled-components';
import { VStack } from '../Core';
import { ItemTrack } from '../Timeline/styles';

export const ItemsWrapper = styled.div<{ $naturalHeight?: boolean }>`
  height: ${({ $naturalHeight }) => ($naturalHeight ? 'auto' : '100%')};
`;

export const ItemWrapper = styled.div`
  padding-right: ${({ theme }) => theme.spacing8}px;
  &.first-item {
    padding-top: ${({ theme }) => theme.spacing12}px;
  }
  &.last-item {
    ${ItemTrack} {
      &:before {
        background: transparent;
      }
    }
  }
`;

export const EmptyDataWrapper = styled(VStack)`
  flex: 1;
  width: 100%;
  min-height: 165px;
`;
